import { css } from '@emotion/css';
import { id, SingleSelect } from 'Shared/forms/Inputs'
import { labelStyle } from 'Shared/forms/Wrap'
import { ColourPicker } from 'Shared/forms/ColourPicker';
import { StoreProvider, useStore } from 'Shared/StoreProvider';
import { createMemo } from 'solid-js';
import { Sides } from 'Shared/backend/widgets/Sides';
import { paneIndentStyle } from 'Shared/backend/widgets/Styles';
import { Amount } from 'Shared/forms/Amount';
import { subdoc } from 'Common/ViewUtils';
import { Selector } from './Margins';



export function Borders(P)
{
	const gridStyle = css(paneIndentStyle(), {
		width: 0,
		display: 'grid',
		gridTemplateColumns: 'auto auto auto auto',
		columnGap: '1em',
		rowGap: '1em',
	});

	const sw = useStore();
	const defaults = () => ({style:'solid',width:'1px',colour:'#ccc'});

	return (
		<div>
			<Selector />

			<Sides
				label='Borders'
				property='border'
				settings={BorderSettings}
				defaults={defaults}
				sides={(subdoc(sw.store, sw.location ?? []) as any)?.border?.sides}
				style={gridStyle}
			/>
		</div>
	);
}

function BorderSettings(P:{label:string,name:string})
{
	const sw = useStore();

	const location = () => [...sw.location,'border',P.name];

	const currentStyle = createMemo(() => (subdoc(sw.store, location()) as any)?.style);

	return (
		<StoreProvider {...sw} location={location()}>
			<label class={labelStyle()} for={id('style')}>{P.label}</label>

			<SingleSelect field='style' required={true} options={{
				none: 'none',
				solid:'solid',
				dotted: 'dotted',
				dashed: 'dashed',
				double: 'double',
				groove: 'groove',
				ridge: 'ridge',
				inset: 'inset',
				outset: 'outset',
				hidden: 'hidden',
			}} />

			<ColourPicker field='colour' />

			<Amount field='width' options={{em:'em',px:'px',percent:'%'}} />
		</StoreProvider>
	);
}

